import React from 'react'
import ReactDOM from 'react-dom/client'
import { SoolProvider } from 'soolui'
import App from './App.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SoolProvider>
      <App />
    </SoolProvider>
  </React.StrictMode>,
)
